import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { all } from '@awesome.me/kit-6af4465e35/icons'

library.add(...all)

// convert i tags to SVG
dom.watch({
    autoReplaceSvgRoot: document,
    observeMutationsRoot: document.body
})
